// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChildHideController from "./child_hide_controller"
application.register("child-hide", ChildHideController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DynamicFormController from "./dynamic_form_controller"
application.register("dynamic-form", DynamicFormController)

import PhotoPreviewController from "./photo_preview_controller"
application.register("photo-preview", PhotoPreviewController)
